// @flow
import path from 'ramda/es/path';

import shopApiRequest from 'app/actions/shopApi';
import action from 'app/common/lib/action';
import { toCamelCase } from 'app/common/lib/object';


export const SHOP_SHIPPING_REQUEST = 'SHOP_SHIPPING_REQUEST';
export const SHOP_SHIPPING_SUCCESS = 'SHOP_SHIPPING_SUCCESS';
export const SHOP_SHIPPING_FAILURE = 'SHOP_SHIPPING_FAILURE';
export const SHOP_SHIPPING_CLEAR = 'SHOP_SHIPPING_CLEAR';
export const SHOP_SHIPPING_CURRENT = 'SHOP_SHIPPING_CURRENT';
export const SHOP_SHIPPING_LOCK = 'SHOP_SHIPPING_LOCK';


/**
 * Запрос методов доставки
 */
export const shippingMethodsFetch = () => async (dispatch: Function) => {
  dispatch(action(SHOP_SHIPPING_REQUEST));
  try {
    const res = await shopApiRequest('shipping_methods', 'get');
    const data = toCamelCase(path(['data', 'data'], res)) || [];
    // const currentShippingId = path([0, 'id'], data) || null;
    // убираем отсюда начальную инициализацию метода доставки, так как он может отфильтроваться позже
    dispatch(action(SHOP_SHIPPING_SUCCESS, { data }));
    return true;
  } catch (error) {
    dispatch(action(SHOP_SHIPPING_FAILURE, {
      err: 'Запрос методов доставки не удался',
      error,
    }));
    return false;
  }
};
